import { useEffect, useMemo } from 'react'

import { useUser } from 'components/user'
import { usePortal } from 'components/portal-provider'

import { ACAP_ADVISOR_USER_ROLES } from 'const/types'
import { routes } from 'const/routes'
import { matchPath, useHistory } from 'router'

const disabledRoutes = [
  routes.addInvestment,
  routes.addInvestmentWithOffering,
  routes.addInvestmentFromDraft,
  routes.addInvestmentFromDraftSupervisor,
  routes.addInvestmentWithIoiOffering,
  routes.addInvestmentWithIoiOfferingDraft,
  routes.addInvestmentWithUser,
  routes.addInvestmentWithUserDraft,

  routes.investorInvestments,

  routes.emailConfirmation,
  routes.registerExtraPage,
  routes.registerThankYouPage,
  routes.completeProfile,
  routes.accountSecurity,

  routes.privacyPolicy,
  routes.termsOfUse,
]

export const AcapRedirect = (props) => {
  const history = useHistory()
  const { tags, pending } = usePortal()
  const isACAPPortal = useMemo(() => tags?.some((tag) => tag?.toLowerCase() === 'acap'), [tags])
  const user = useUser()
  useEffect(() => {
    //disable sending data before receiving portal data
    if (pending || !isACAPPortal || !user) return

    const fullAccess = user?.roles?.some((role) => ACAP_ADVISOR_USER_ROLES.includes(role))

    const pathName = history.location.pathname
    if (
      fullAccess ||
      disabledRoutes.some((route) => matchPath(pathName, { path: route, exact: false }))
    ) {
      //disable redirect from available routes
      return
    }

    history.replace(routes.investorInvestments)
  }, [history, history.location, isACAPPortal, pending, user])

  return false
}

AcapRedirect.propTypes = {}
